<template>
  <div>
    <v-title>Address Detail</v-title>
    <v-card>
      <v-card-text>
        <v-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12 md12 lg12>
                <!--<v-autocomplete v-model="streetAddress"
                                                :items="results"
                                                :search-input.sync="search"
                                               :filter="customFilter"
                                                item-text="formatted_address"
                                                item-value="famatted_address"
                                                label="Search for physical street address, not PO Box"
                                                placeholder="Start typing to Search"
                                              
                autocomplete="dont-autocomplete"></v-autocomplete>-->
                <v-autocomplete
                  :items="results"
                  label="Search for physical street address, not PO Box"
                  :search-input.sync="search"
                  v-model="streetAddress"
                  item-text="formatted_address"
                  item-value="formatted_address"
                  @change="completeAddress"
                  :filter="customFilter"
                  persistent-hint
                  browser-autocomplete="off"
                >
                  <template slot="nodata" slot-scope="data"></template>
                </v-autocomplete>
              </v-flex>
              <v-flex sm6 md6 lg6>
                <v-text-field
                  :disabled="true"
                  label="Street Address"
                  type="text"
                  name="streetAddress"
                  v-validate="'required'"
                  v-model="streetAddress"
                ></v-text-field>
                <span
                  v-show="errors.has('streetAddress')"
                  class="red--text"
                >{{ errors.first('streetAddress') }}</span>
              </v-flex>
              <v-flex sm6 md6 lg6>
                <v-text-field
                  :disabled="true"
                  label="Suburb"
                  type="text"
                  name="suburb"
                  v-validate="'required'"
                  v-model="suburb"
                ></v-text-field>
                <span v-show="errors.has('suburb')" class="red--text">{{ errors.first('suburb') }}</span>
              </v-flex>
              <v-flex sm3 md3 lg3>
                <v-text-field
                  :disabled="true"
                  label="State"
                  name="state"
                  v-model="state"
                  v-validate="'required'"
                ></v-text-field>

                <span v-show="errors.has('state')" class="red--text">{{ errors.first('state') }}</span>
              </v-flex>
              <v-flex sm3 md3 lg3>
                <v-text-field
                  :disabled="true"
                  label="Postcode"
                  type="text"
                  name="postCode"
                  v-validate="'required|numeric'"
                  v-model="postCode"
                ></v-text-field>
                <span
                  v-show="errors.has('postCode')"
                  class="red--text"
                >{{ errors.first('postCode') }}</span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn v-if="send" @click="sendAddress" color="primary">Send</v-btn>
            <v-btn v-if="!send" @click="addAddressToList" color="primary">Save</v-btn>
            <v-btn @click="$emit('close')" color="light-grey">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { createNamespacedHelpers } from "vuex";
import { HTTP } from "@/http-common";
import { mapAddressFields, mapCustomerFields } from "@/store/modules/orders";
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapAddressActions,
  mapMutations: mapAddressMutations
} = createNamespacedHelpers(`orders/address`);
const { mapActions: mapCustomerActions } = createNamespacedHelpers(
  `orders/customer`
);

export default {
  props: {
    addressList: Array,
    send: Boolean
  },
  data() {
    return {
      isDataLoading: false,
      isSaved: false,

      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null,
      streetAddress: null,
      suburb: null,
      state: null,
      postCode: null,
      results: [],
      address: null,
      fullAddress: null
    };
  },
  mounted() {},
  methods: {
    ...mapAddressActions(["searchAddress", "createAddress"]),
    clearDropdown: function(e) {
      let vm = this;
      vm.results = [];
    },
    addAddressToList() {
      let vm = this;
      if (vm.fullAddress) {
        vm.addressList.push(vm.fullAddress);
        vm.$emit("close");
      }
    },
    sendAddress() {
      let vm = this;
      
      if (vm.fullAddress)
        vm.$emit("sendAddress", vm.fullAddress.formattedAddress);
    },
    completeAddress(event) {
      let vm = this;
      var match = vm.results.filter(x => x.formatted_address === event);
      var data = { match, event };
      vm.createAddress(data).then(res => {
        vm.fullAddress = res;
        vm.suburb = vm.fullAddress.suburb;
        vm.state = vm.fullAddress.state;
        vm.postCode = vm.fullAddress.postCode;
        vm.streetAddress = vm.fullAddress.streetAddress;
      });
    },
    customFilter(item, queryText, itemText) {
      return true;
      var words = queryText.split(" ").filter(x => x.length > 0);
      var result = false;
      words.forEach(x => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    }
  },
  watch: {
    search(val) {
      if (val !== null) {
        if (val.length > 5)
          this.searchAddress(val).then(res => (this.results = res));
      }
    }
  }
};
</script>
